import { render } from "./CategoryView.vue?vue&type=template&id=b648c4de&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=b648c4de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b648c4de"

export default script